import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import PropTypes from 'prop-types';
import { faHistory } from '@fortawesome/pro-solid-svg-icons/faHistory';
import { Icon } from '@veeva/corgix/icon';
import { useTheme } from 'emotion-theming';
import {
    searchResultLinkCSS,
    searchResultLinkCustomerCategoryCSS,
    searchResultLinkFamilyCategoryCSS,
    searchResultLinkPlatformCategoryCSS,
} from './styles/RecentlySearchedSearchResultLink.styles';
import PageGroupType from './PageGroupType';
import getTagCharacterForSearchLink from '../services/getTagCharacterForSearchLink';

export default function RecentlySearchedSearchResultLink({
    category,
    className,
    label,
    searchWords,
    url,
}) {
    const theme = useTheme();
    const tagStyling = [
        category === PageGroupType.CUSTOMER && searchResultLinkCustomerCategoryCSS(theme),
        category === PageGroupType.FAMILY && searchResultLinkFamilyCategoryCSS(theme),
        category === PageGroupType.PLATFORM && searchResultLinkPlatformCategoryCSS(theme),
    ];

    return (
        <Link className={className} css={searchResultLinkCSS} to={url}>
            <div>
                <span css={tagStyling}>{getTagCharacterForSearchLink(category)}</span>
                <Highlighter
                    searchWords={searchWords ?? []}
                    highlightTag="strong"
                    autoEscape
                    textToHighlight={label}
                />
            </div>
            <Icon type={faHistory} size="sm" />
        </Link>
    );
}

RecentlySearchedSearchResultLink.propTypes = {
    category: PropTypes.oneOf(Object.values(PageGroupType)),
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    searchWords: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
};
